import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import ComponentHeader from '../commoncomponents/ComponentHeader';
import BottomButtonsforWorkOrder from './BottomButtonsforWorkOrder';
import SignatureGrid from './SignatureGrid';
import {
    getAuthToken,
    getCreatedBy,
    getFacilityId,
} from "../../utility/tokenUtility";
import { checkIsafterImageAttachmentUploaded, updateBasicDetailsWorkOrder, updateWorkOrderStatus } from '../../redux/actions/workOrderActionTypes';
import workOrderSummaryRepositry from '../../api/repositories/workOrderSummaryRepositries';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTooltip from '../commoncomponents/CustomTooltip';
import { format, isValid, parseISO } from "date-fns";
import CreateWOTaskDetails from '../workordercomponents/CreateWOTaskDetails';
import { Schedule } from '@mui/icons-material';
import { processingPercentageValue, statusList } from '../../utility/message';
const Attachments = ({ setPage, buttonAttributes, page }) => {

    //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const createdBy = getCreatedBy("createdBy");
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const basicDetails = useSelector((state) => state.workOrderBasicDetails);
    const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const token = getAuthToken("id_token");
    const facilityId = getFacilityId('facilityId');

    const completionInfoData = basicDetails?.completionInfo || {};
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const categoryType = assetCategoryType?.category;
    const checkCategoryType = categoryType === "Scheduled" ? true : false;
    const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const viewmode = location.state?.viewmode;


    const [rows, setRows] = useState([{
        id: 1,
        file: null,
        documenttitle: '',
        documenttype: '',
        filesize: '',
    }]);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [gridApi, setGridApi] = useState(null);
    const [attachmentMandatory, setAttachmentMandatory] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [signatureRows, setSignatureRows] = useState([
        {
            id: 1,
            category: '',
            fileType: '',
            designation: '',
            size: '',
        }
    ]);
    const [signatureDeleteDialog, setSignatureDeleteDialog] = useState(false);
    const [signatureId, setSignatureId] = useState(null);
    const [signatureDialog, setsignatureDialog] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [getByIdSignatures, setGetByIdSignatures] = useState([]);
    const [isSignatureAffected, setIsSignatureAffected] = useState(false);
    const [dropDownValue, setDropDownValue] = useState("");
    const [dropdownError, setDropdownError] = useState(false);
    const [dropDownErrorMessage, setDropDownErrorMessage] = useState("");
    const[checkImagesErrorMessage,setCheckImagesErrorMessage]  = useState("");
    const [workRequestAttachmentRows, setWorkRequestAttachmentRows] = useState([]);
    const [pageName, setPageName] = useState("Part Replacement");
    const [taskDetails, setTaskDetails] = useState({
        performanceTest: basicDetails?.performancetest || "",
        electricalSafetyTest: basicDetails?.electricalsafteytest || "",
        processStatus: basicDetails?.processstatus || "",
    });

    const taskDetailsOptions = {
        performanceTest: [{ id: 1, label: "Done" }, { id: 2, label: "Not Done" }, { id: 3, label: "Not Applicable" }, { id: 4, label: "Fail" }],
        electricalSafetyTest: [{ id: 1, label: "Done" }, { id: 2, label: "Not Done" }, { id: 3, label: "Not Applicable" }, { id: 4, label: "Fail" }],
        processStatus: [
            { id: 1, label: "Purpose For BER" },
            { id: 2, label: "Required Parts" },
            { id: 3, label: "Equipment In Use" },
            { id: 4, label: "Technical Advice" },
            { id: 5, label: "Equipment not at Location" },
            { id: 6, label: "Loaner Provision" },
            { id: 7, label: "Alternative Service" }
        ]
    };

    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed": 7,
        "Completed-Outsource": 9,
    };

    const attachmentTypeOptions = [
        { id: 1, label: "Before" },
        { id: 2, label: "After" },
        { id: 3, label: "Others" },
    ];

    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null;

    function AddRowButton(props) {
        const handleClick = () => {
            props.onClick();
        };

        return (

            <Box sx={{ mb: 1 }}>

                <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick} >
                    Add Row
                </Button>
            </Box>
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }

        try {
            let date;
            date = parseISO(dateString);

            if (!isValid(date)) {
                date = new Date(dateString);
            }

            if (!isValid(date)) {
                return 'Invalid Date';
            }

            const formattedDate = format(date, 'dd/MM/yyyy');
            return formattedDate;

        } catch (error) {
            console.error('Error parsing date:', error.message);
        }
    };

    const fetchFiles = async () => {

        const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
        const checkFieldName = serviceType === "fem" ? "fem" : "bem"
        const getAttachementCategory = categoryType === "Scheduled" ? "GetscheduledAttachmentsList" : "GetunscheduledAttachmentsList";
        let workRequestId = basicDetails?.referenceWorkRequestNo?.id || "";

        let workRequestAttachmentRows = [];

        try {
            const response = await axios.get(`${checkGraph}/api/${checkFemorBem}unscheduledworkorder/${getAttachementCategory}/${basicDetails?.id},1,1000`, config);
            if (workRequestId) {
                const workRequestAttachment = await axios.get(`${checkGraph}/api/Graph${checkFieldName}Departmentrequest/Getdepartmentattachmentlist${checkFieldName}/${workRequestId}`, config);
                workRequestAttachmentRows = workRequestAttachment?.data || [];

            };
            const fetchedFiles = response?.data;

            const gridRows = fetchedFiles.map((file) => {
                const attachmentTypeId = file?.[`${checkFieldName}woattachmenttypeId`] || "";
                const attachmentTypeOption = attachmentTypeOptions.find(option => option?.id === attachmentTypeId);

                setDropDownValue(prev => ({
                    ...prev,
                    [file?.id]: attachmentTypeOption || { id: 3, label: "Others" },
                }));

                return {
                    id: file?.id,
                    filename: file?.filename,
                    filepath: file?.filepath,
                    filesize: file?.filesize,
                    documenttitle: file?.documenttitle,
                    documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
                    attachmentType: attachmentTypeOption || { id: 3, label: "Others" },
                };
            });

            const workRequestRows = workRequestAttachmentRows?.map((file) => {
                const allowedImageTypes = ['jpeg', 'jpg', 'png'];
                const setAttachmentType = allowedImageTypes.includes(file?.filedesc?.toLowerCase())
                    ? { id: 1, label: "Before" } : { id: 3, label: "Others" };
                setDropDownValue(prev => ({
                    ...prev,
                    [file?.id]: setAttachmentType,
                }));

                return {
                    id: file?.id,
                    filename: file?.filename,
                    filepath: file?.filepath,
                    filesize: file?.filesize,
                    documenttitle: file?.documenttitle,
                    documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
                    attachmentType: setAttachmentType,
                    workRequestFile: true
                };
            });

            let mainRows = [...(gridRows || []), ...(workRequestRows || [])];

            if (gridRows?.length > 0 || workRequestRows?.length > 0) {
                setRows(mainRows);
            } else if (viewmode == true || mappedStatus === 6 || mappedStatus === 7) {
                setRows(mainRows);
            }
            else {
                const newRow = {
                    id: 1,
                    documenttitle: '',
                    file: '',
                    documenttype: '',
                    filesize: '',
                    attachmentType: { id: 3, label: "Others" }
                };
                setDropDownValue((prev) => ({
                    ...prev,
                    [newRow?.id]: { id: 3, label: "Others" }
                }));
                setRows([newRow]);
            }
        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };

    useEffect(() => {
        fetchFiles();

        if (basicDetails?.assessments?.partsRequired?.id === 1) {
            setPageName("Part Replacement");
        } else if (basicDetails?.assessments?.partsRequired?.id === 2) {
            setPageName("Completion Info");
        } else {
            setPageName("Part Replacement");
        }
    }, []);

    const handleDeleteClick = (id) => () => {
        const selectedRow = rows.find(row => row.id === id);
        if (rows.length === 1 && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
            return;
        }
        if (selectedRow && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
            const updatedRows = rows.filter((row) => row.id !== id);
            setRows(updatedRows);
            const updatedSelectedFiles = selectedFiles.filter(file => file.id !== id);
            setSelectedFiles(updatedSelectedFiles);
        } else if (selectedRow) {
            setSelectedId(id);
            setDeleteDialogOpen(true);
        }
    };

    const handleDeleteConfirm = async () => {
        const selectedRow = rows.find(row => row.id === selectedId);
        if (rows.length === 1 && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
            setDeleteDialogOpen(false);
            return;
        }

        if (selectedRow) {
            try {
                if (typeof selectedId === 'string') {
                    const response = await axios.delete(
                        `${checkGraph}/api/${serviceType}${categoryFieldName}woattachements/${selectedId}`,
                        config
                    );

                    if (response.status >= 200 && response.status <= 204) {
                        const updatedRows = rows.filter((row) => row.id !== selectedId);
                        setRows(updatedRows);
                        const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
                        setSelectedFiles(updatedSelectedFiles);
                        fetchFiles();
                        const hasAfterImage = updatedRows?.some(row => row?.attachmentType?.id === 2);                        
                        dispatch(checkIsafterImageAttachmentUploaded("CHECK_ISASFTER_IMAGE_ATTACHMENT_UPLOADED", hasAfterImage));
                    } else {
                        throw new Error('Failed to delete record');
                    };
                } else if (typeof selectedId === 'number') {
                    const updatedRows = rows.filter((row) => row.id !== selectedId);
                    setRows(updatedRows);
                    const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
                    setSelectedFiles(updatedSelectedFiles);
                    if (updatedRows.length < 1) {
                        fetchFiles();
                    };
                };
            } catch (error) {
                setError(true);
                setErrorMessage('Error deleting attachment. Please try again.');
            }
        }
        setDeleteDialogOpen(false);
    };

    const handleDeleteDialogClose = () => {
        setDeleteDialogOpen(false);
    };

    const handleAddRow = () => {
        const id =
            rows.length > 0
                ? Math.max(...rows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
                : 1;
        const newRow = {
            id: id,
            file: "",
            documenttitle: '',
            documenttype: '',
            filesize: '',
            attachmentType: { id: 3, label: "Others" }
        };
        setRows((oldRows) => [...oldRows, newRow]);
        setDropDownValue((prev) => ({
            ...prev,
            [id]: { id: 3, label: "Others" },
        }));

        setDropdownError((prev) => ({
            ...prev,
            [id]: false,
        }));

        setDropDownErrorMessage((prev) => ({
            ...prev,
            [id]: "",
        }));
    };

//     const handleFileChange = (event, id) => {
//         const file = event.target.files[0];
//         if (!file) return;
//         const fileName = file.name;
//         const fileExtension = fileName.split('.').pop().toLowerCase();

//         if (file.size > 20 * 1024 * 1024) {
//             setError(true);
//             setErrorMessage('Error: File size exceeds 20 MB. Please select smaller files.');
//             return;
//         };

//         // Get dropdown value for the row
//         const dropdownValue = dropDownValue[id];
//         const isAfterOrBefore = dropdownValue?.id === 1 || dropdownValue?.id === 2;
//         const allowedFileExtensions = isAfterOrBefore ? ['jpeg', 'jpg', 'png'] : ['doc', 'jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'docx'];

//         // Check file type validity
//         if (!allowedFileExtensions.includes(fileExtension)) {
//             setError(true);
//             setErrorMessage(isAfterOrBefore
//                 ? 'Error: Only JPEG, JPG, and PNG files are allowed for this selection.'
//                 : 'Error: Only DOC, JPEG, JPG, PNG, XLSX, CSV, and PDF files are allowed.'
//             );

//             // Show attachment type dialog for invalid files on "after" or "before" selections
//             if (isAfterOrBefore) {
//                 // setAttachmentTypeDialog(true);
//                 setDropDownValue(prev => ({
//                     ...prev,
//                     [id]: { id: 3, label: "Others" }, // Reset dropdown if invalid file is chosen
//                 }));
//             }
//             return;
//         }

//         let updatedSelectedFiles = [...selectedFiles];
//         const fileIndex = updatedSelectedFiles.findIndex((file) => file.id === id);
//         if (fileIndex > -1) {
//             updatedSelectedFiles[fileIndex] = { id, file };
//         } else {
//             updatedSelectedFiles.push({ id, file });
//         };
//         setSelectedFiles(updatedSelectedFiles);

//         const updatedRows = rows.map((row) => {
//             if (row.id === id) {
//                 let fileSize;
//                 if (file.size >= 1024 * 1024) {
//                     fileSize = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
//                 } else {
//                     fileSize = (file.size / 1024).toFixed(2) + ' KB';
//                 };

//                 return {
//                     ...row,
//                     file,
//                     documenttitle: fileName,
//                     documenttype: fileExtension,
//                     filesize: fileSize,
//                 };
//             };
//             return row;
//         });
// console.log(updatedRows, "Updated Rows");

//         setRows(updatedRows);
//         setAttachmentMandatory(false);
//         setHasUnsavedChanges(true);
//     };

const handleFileChange = (event, id) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();

    // File size validation
    if (file.size > 20 * 1024 * 1024) {
        setError(true);
        setErrorMessage('Error: File size exceeds 20 MB. Please select smaller files.');
        return;
    }

    // Get dropdown value for the row
    const dropdownValue = dropDownValue[id];
    const isAfterOrBefore = dropdownValue?.id === 1 || dropdownValue?.id === 2;

    const allowedFileExtensions = isAfterOrBefore
        ? ['jpeg', 'jpg', 'png']
        : ['doc', 'jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'docx'];

    // File type validation
    if (!allowedFileExtensions.includes(fileExtension)) {
        setError(true);
        setErrorMessage(isAfterOrBefore
            ? 'Error: Only JPEG, JPG, and PNG files are allowed for this selection.'
            : 'Error: Only DOC, JPEG, JPG, PNG, XLSX, CSV, and PDF files are allowed.'
        );

        // Reset dropdown if it's invalid for Before/After
        if (isAfterOrBefore) {
            setDropDownValue(prev => ({
                ...prev,
                [id]: { id: 3, label: "Others" },
            }));
        }
        return;
    }

    // Update selected files state
    let updatedSelectedFiles = [...selectedFiles];
    const fileIndex = updatedSelectedFiles.findIndex(f => f.id === id);
    if (fileIndex > -1) {
        updatedSelectedFiles[fileIndex] = { id, file };
    } else {
        updatedSelectedFiles.push({ id, file });
    }
    setSelectedFiles(updatedSelectedFiles);

    // Update row data with file and attachment type
    const updatedRows = rows.map((row) => {
        if (row.id === id) {
            let fileSize;
            if (file.size >= 1024 * 1024) {
                fileSize = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
            } else {
                fileSize = (file.size / 1024).toFixed(2) + ' KB';
            }

            return {
                ...row,
                file,
                documenttitle: fileName,
                documenttype: fileExtension,
                filesize: fileSize,
                attachmentType: dropDownValue[id] || row.attachmentType,
            };
        }
        return row;
    });

    //     // Re-validate based on updated rows
    // const updatedGridRows = updatedRows.filter(row =>
    //     row?.documenttitle || row?.file || row?.documenttype || row?.filesize
    // );

    // const attachmentTypeIds = updatedGridRows.map(row => row?.attachmentType?.id).filter(Boolean);

    // const hasBefore = attachmentTypeIds.includes(1);
    // const hasAfter = attachmentTypeIds.includes(2);

    // let mandatoryError = false;

    // if (categoryType === "Unscheduled") {
    //     mandatoryError = !(hasBefore && hasAfter); // Both are required
    // } else if (categoryType === "Scheduled") {
    //     mandatoryError = !hasBefore; // Only Before is required
    // }

    // setAttachmentMandatory(mandatoryError);

    setRows(updatedRows);
    setAttachmentMandatory(false);
    setHasUnsavedChanges(true);
};


    const handleDownload = async (file) => {
        try {
            const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${file.filename}`, {
                ...config,
                responseType: 'blob'
            });

            if (response) {
                const url = URL.createObjectURL(response.data);
                const a = document.createElement('a');
                a.href = url;
                a.download = file.documenttitle || file.filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
            else {
                if (file && file instanceof Blob) {
                    const url = URL.createObjectURL(file);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = file.documenttitle || file.filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                } else {
                    console.error('Invalid file object:', file);
                };
            };
        } catch (error) {
            console.error('Error downloading file:', error);
        };
    };


    const handleDownloadClick = (event, file) => {
        event.preventDefault();
        handleDownload(file);
    };
    function uuidv4(extension) {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }) + '.' + extension;
    };

    const uploadFiles = async (formData) => {
        try {
            let storeFileNameArray = [];
            let storeregsitredFilesResponse = [];
            let storefileUploadResponse = [];
            for (let i = 0; i < selectedFiles?.length; i++) {
                const formData = new FormData();
                const extension = selectedFiles[i]?.file?.name.split('.').pop();
                const fileName = uuidv4(extension); // generate a unique id
                formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
                storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.file?.name}`, selectedFileId: selectedFiles[i]?.id });

                try {
                    const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
                    storeregsitredFilesResponse.push(fileUploadResponse.data);
                    storefileUploadResponse.push(fileUploadResponse.data);
                } catch (error) {
                    console.log('Error uploading file:', error.response ? error.response.data : error.message);
                }
            }
            return { storefileUploadResponse, storeFileNameArray };
        } catch (error) {
            console.log('Save error:', error);
            throw error;
        }
    };

    const saveFilesToAttachment = async (payload) => {
        try {
            const response = await axios.post(`${checkGraph}/api/${serviceType}${categoryFieldName}woattachements`, payload, config);
            return response.data;
        } catch (error) {
            console.error('Save error:', error);
        };
    };

    const handleSaveClick = async (event) => {
        event.preventDefault();
        let hasError = false;
        rows.forEach((row) => {
            const rowId = row?.id;
            const value = dropDownValue[rowId];

            // If value is empty and documenttitle exists, trigger an error
            if ((!value || value === "") && row?.documenttitle) {
                hasError = true;

                // Set error state for this row
                setDropdownError((prev) => ({
                    ...prev,
                    [rowId]: true,
                }));

                setDropDownErrorMessage((prev) => ({
                    ...prev,
                    [rowId]: "This field is required",
                }));
            } else {
                // Clear error state for this row if it is valid
                setDropdownError((prev) => ({
                    ...prev,
                    [rowId]: false,
                }));

                setDropDownErrorMessage((prev) => ({
                    ...prev,
                    [rowId]: "",  // Clear error message
                }));
            }
        });

        // Stop submission if there are errors
        if (hasError) {
            return;
        };

        const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
        if (selectedFiles.length > 0) {
            try {
                const filteredSelectedFiles = selectedFiles.filter(file => rows.some(row => row.id === file.id));
                if (filteredSelectedFiles.length > 0) {
                    const { storefileUploadResponse, storeFileNameArray } = await uploadFiles(filteredSelectedFiles);

                    if (storefileUploadResponse?.length > 0) {
                        let storefileUploadResponseFinal = [];

                        for (let i = 0; i < storefileUploadResponse.length; i++) {
                            const file = storefileUploadResponse[i];
                            const selectedFileId = storeFileNameArray[i];

                            const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;
                            const documenttype = documentTitle.split('.').pop().toLowerCase();
                            if (documentTitle) {
                                const rowId = selectedFileId?.selectedFileId || "";
                                const attachementTypeValue = dropDownValue[rowId];

                                const payload = {
                                    filename: file.fileName,
                                    filesize: file.fileSize,
                                    filepath: "D:/IFAC-X/UploadFolder",
                                    documenttitle: documentTitle,
                                    [`${checkFemorBem}${categoryFieldName}workorderheaderId`]: basicDetails?.id,
                                    createdby: createdBy,
                                    documenttype: documenttype,
                                    [`${checkFemorBem}woattachmenttypeId`]: attachementTypeValue?.id || ""
                                };

                                try {
                                    const response = await saveFilesToAttachment(payload);
                                    setHasUnsavedChanges(false);
                                    if (response) {
                                        storefileUploadResponseFinal.push(response);
                                        fetchFiles();
                                        
                                       // dispatch(checkIsafterImageAttachmentUploaded("CHECK_IS_AFTER_IMAGE_ATTACHMENT_UPLOADED",  true));

                                       const hasAfterImage = rows?.some(row => row?.attachmentType?.id === 2);                                       
                                      dispatch(checkIsafterImageAttachmentUploaded("CHECK_ISASFTER_IMAGE_ATTACHMENT_UPLOADED", hasAfterImage));

                                    }
                                } catch (error) {
                                    console.log('Error saving file:', error);
                                }
                            } else {
                                console.log("Document Title not found for file:", file.fileName);
                            }
                        }

                    } else {
                        console.log("No files registered");
                    }
                }

            } catch (error) {
                console.log('Error registering files:', error);
            }

        } else {
            console.log("No files selected for upload");
        }
    };

    const handleSaveHeaderTable = async () => {

        const payload_for_HeaderTable = {
            workorderno: basicDetails?.workOrderNo || "",
            workorderdate: basicDetails?.workorderDateandTime || "",
            targetdate: categoryType === "Scheduled" ?
                basicDetails?.issueDateandTimeBasicDetails : (basicDetails?.issueDateandTimeBasicDetails
                    ? basicDetails?.issueDateandTimeBasicDetails : basicDetails?.workorderDateandTime),
            requestor: basicDetails?.requestor || "",
            designation: basicDetails?.designation || "",
            receiveddate: basicDetails?.recivedDateandTime || "",
            contactno: basicDetails?.contactNo || "",
            requestdetails: basicDetails?.requestDetails || "",
            receivedbyid: basicDetails?.receivedbyid || "",
            cancelledby: basicDetails?.cancelledBy || "",
            cancellationreason: basicDetails?.reasonforCancellation || "",
            isppmused: basicDetails?.isppmused || false,
            [`${serviceType}assetregisterId`]: basicDetails?.assetNo?.id || "",
            [`${serviceType}workorderstatusId`]: basicDetails?.editmode ? mappedStatus : 1 || "", //1 for  open status id while creating the work order
            [`${serviceType}workordertypeId`]: basicDetails?.type?.id || 1,
            [`${serviceType}workorderpriorityId`]: basicDetails?.priority?.id || "",
            [`${serviceType}workordersafetyperformtestId`]: basicDetails?.femworkordersafetyperformtestId || "",
            [`${serviceType}wotargetresponseId`]: basicDetails?.priority?.id || "",
            completeddate: basicDetails?.completeddate || "",
            [`${serviceType}departmentworkrequestheaderId`]: basicDetails?.referenceWorkRequestNo?.id || "",
            [`${serviceType}ppmscheduletrackId`]: basicDetails?.ppmscheduletrackId || "",
            [`${serviceType}predictivemaintenancetrackId`]: basicDetails?.pdmscheduletrackId || "",
            id: basicDetails?.id || "",
            Processingpercentage: basicDetails?.editmode ? processingPercentage : 16 || "", //16 for processing percentage while creating the work order
            timestamp: basicDetails?.timeStamp || "",
            facilityid: facilityId || "",
            token: token || "",
            isverify: location?.state?.isverify === "Yes" ? 1 : "",
            performancetest: taskDetails?.performanceTest || "",
            electricalsafteytest: taskDetails?.electricalSafetyTest || "",
            processstatus: taskDetails?.processStatus || "",
            istransfer: basicDetails?.isTransfer || false,
            transfertoid: basicDetails?.transfertoId || "",
            // completeddate: basicDetails?.completeddate || "",
            // completedby: basicDetails?.completedby || "",
        };

        await workOrderSummaryRepositry.updateBasicDetails(serviceType, payload_for_HeaderTable, categoryType);
        dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", {
            basicDetails,
            isverify: location?.state?.isverify || "",
            isresponse: location?.state?.isresponse || "",
            performancetest: taskDetails?.performanceTest || "",
            electricalsafteytest: taskDetails?.electricalSafetyTest || "",
            processstatus: taskDetails?.processStatus || ""
        }));

    };    

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (viewmode == true || mappedStatus === 6 || mappedStatus === 7) {
            setPage(pageName);
        } else {
            //     let hasError = false;
            //   // Check if rows length is greater than 1 and there are meaningful rows
            //   const gridRows = rows?.filter(row => row?.documenttitle || row?.file || row?.documenttype || row?.filesize);
            //   if (gridRows?.length < 1) {
            //       hasError = true;
            //       setAttachmentMandatory(true);
            //       return;
            //       }

            // let hasError = false;

            // // Extract selected IDs from attachment options
            // const selectedAttachmentTypeIds = attachmentTypeOptions?.map(opt => opt.id) || [];
            // console.log(selectedAttachmentTypeIds, "Selected Attachment Type IDs");
            // console.log(checkCategoryType, "Check Category Type");

            // // Filter meaningful rows
            // const gridRows = rows?.filter(row =>
            //     row?.documenttitle || row?.file || row?.documenttype || row?.filesize
            // );
            // console.log(gridRows, "Filtered Grid Rows");

            // // Determine if the condition is valid based on category type
            // const validAttachmentType = checkCategoryType
            //     ? selectedAttachmentTypeIds.includes(1) && gridRows?.length > 0
            //     : (selectedAttachmentTypeIds.includes(1) || selectedAttachmentTypeIds.includes(2)) && gridRows?.length > 0;

            // console.log(validAttachmentType, "Valid Attachment Type");

            // // Trigger error if condition fails
            // if (!validAttachmentType) {
            //     hasError = true;
            //     setAttachmentMandatory(true);
            //     return;
            // }

            
                let hasError = false;

                // Filter rows with meaningful values
                const gridRows = rows?.filter(row =>
                    row?.documenttitle || row?.file || row?.documenttype || row?.filesize
                );
                // Get all attachment type IDs from valid rows
                const attachmentTypeIds = gridRows?.map(row => row?.attachmentType?.id).filter(Boolean);

                // Check presence of required types
                const hasBefore = attachmentTypeIds.includes(1);
                const hasAfter = attachmentTypeIds.includes(2);

                if (categoryType === "Unscheduled") {
                    if (!hasBefore) {
                        setCheckImagesErrorMessage("Please add the 'Before' image.");
                        //checkImagesErrorMessage = "Please add both 'Before' and 'After' images.";
                        hasError = true;
                    // } else if (!hasBefore) {
                    //     setCheckImagesErrorMessage("");
                    //     //checkImagesErrorMessage = "Please add the 'Before' image.";
                    //     hasError = true;
                    // } else if (!hasAfter) {
                    //     setCheckImagesErrorMessage("Please add the 'After' image.");
                    //     //checkImagesErrorMessage = "Please add the 'After' image.";
                    //     hasError = true;
                     }
                } else if (categoryType === "Scheduled") {
                    if (gridRows?.length < 1) {
                        //setCheckImagesErrorMessage("Please add the 'Before' image.");
                        setCheckImagesErrorMessage("Please add at least one Attachment.");
                        //checkImagesErrorMessage = "Please add the 'Before' image.";
                        hasError = true;
                    }
                }

                if (hasError) {
                    //console.log("Validation Error:", checkImagesErrorMessage);
                    setAttachmentMandatory(true);
                    // setError(true);
                    // setErrorMessage(checkImagesErrorMessage);
                    return;
                }


            

            if (taskDetails?.performanceTest || taskDetails?.electricalSafetyTest || taskDetails?.processStatus) {
                await handleSaveHeaderTable();
            }

            await handleSaveClick(event);
            if (processingPercentage === 100 && !viewmode) {
                dispatch(checkIsafterImageAttachmentUploaded("CHECK_ISASFTER_IMAGE_ATTACHMENT_UPLOADED", true));
                setPage(pageName);
            } else if ((mappedStatus === 4 && processingPercentage > 50) || mappedStatus === 5 || mappedStatus === 8 || mappedStatus === 9) {                                    
                dispatch(checkIsafterImageAttachmentUploaded("CHECK_ISASFTER_IMAGE_ATTACHMENT_UPLOADED", true));
                setPage(pageName);
            } else {
                const statusId = basicDetails?.assessments?.repairType === "Outsource" ? statusList?.inProgressOutsource?.id : statusList?.inProgress?.id //To get the status ID
                await workOrderSummaryRepositry.workorderStatusValue(serviceType, basicDetails?.id, statusId, processingPercentageValue?.workOrderAttachments, basicDetails?.category?.id);
                dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: processingPercentageValue?.workOrderAttachments}));
                const hasAfterImage = rows?.some(row => row?.attachmentType?.id === 2);                                       
                dispatch(checkIsafterImageAttachmentUploaded("CHECK_ISASFTER_IMAGE_ATTACHMENT_UPLOADED", hasAfterImage));
                setPage(pageName);
            }
        }

    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    const handleCancelDialogConfirm = () => {
        setCancelDialogOpen(false);
        navigate(-1, { replace: true });
    };


    const handleSnackbarClose = () => {
        setError(false);
    };

    const handleOnChange = (value, rowId) => {
        const rowIndex = rows?.findIndex(row => row?.id === rowId);

        if (rowIndex === -1) {
            return;
        };

        setDropDownValue(prev => ({
            ...prev,
            [rowId]: value,
        }));

        setDropdownError((prevErrors) => ({
            ...prevErrors,
            [rowId]: false,
        }));
        setDropDownErrorMessage((prevMessages) => ({
            ...prevMessages,
            [rowId]: '',
        }));

        const allowedImageTypes = ['jpeg', 'jpg', 'png'];

        // Check if the selected id is 1 or 2 and validate document type
        if ((value?.id === 1 || value?.id === 2) && rows[rowIndex]?.documenttype) {
            const documentType = rows[rowIndex]?.documenttype?.toLowerCase();

            if (!allowedImageTypes?.includes(documentType)) {
                setError(true);
                setErrorMessage("Error: Only JPEG, JPG, and PNG files are allowed for this selection.");
                setDropDownValue(prev => ({
                    ...prev,
                    [rowId]: { id: 3, label: "Others" },
                }));
            };
        };
    };

    const handleCheckboxGroupChange = (category, newValues) => {
        setTaskDetails((prev) => ({
            ...prev,
            [category]: newValues
        }));
    };

    return (
        <>
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
                statusType={"completed"}
            />
            <Box  >
                <form style={{ position: 'relative' }} onSubmit={handleSubmit}>
                    <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                        <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.workOrderNo || ""}</Typography>
                    </Stack>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {!viewmode && mappedStatus !== 6 && mappedStatus !== 7 && <AddRowButton onClick={handleAddRow} />}
                    </Grid>
                    {attachmentMandatory && (<Typography component={"span"} color={"error"}>
                        {checkImagesErrorMessage}*
                    </Typography>)}

                    <CustomAgGrid
                        rows={rows}
                        columns={[
                            {
                                field: 'attachmentType',
                                headerName: 'Image Type',
                                minWidth: 200,
                                cellRenderer: (params) => {
                                    const rowId = params?.data?.id || "";
                                    const selectedOption = dropDownValue[rowId] || { id: 3, label: "Others" };
                                    const currentId = selectedOption?.id || params?.data?.attachmentType || "";
                                    const currentOption = attachmentTypeOptions.find(option => option?.id === currentId);
                                    const currentLabel = selectedOption?.label || currentOption?.label || '';
                                    const OptionsValue = selectedOption?.id ? selectedOption : { id: currentId, label: currentLabel };
                                    const disablefield = params?.data?.filename ? true : false;

                                    return (
                                        <Box sx={{ padding: "2px", marginBottom: '0rem', marginTop: '0rem' }} >
                                            <Grid>
                                                <CustomSelectInput
                                                    error={dropdownError[rowId]}
                                                    errorMessage={dropDownErrorMessage[rowId]}
                                                    name="isBefore"
                                                    value={OptionsValue || ""}
                                                    options={attachmentTypeOptions || []}
                                                    onChange={(value) => handleOnChange(value, rowId)}
                                                    disabled={params.data?.documenttitle || mappedStatus === 6 || mappedStatus === 7}

                                                />
                                            </Grid>
                                        </Box>
                                    );
                                },
                            },
                            {
                                field: 'file',
                                headerName: 'File',
                                flex: 1,
                                cellRenderer: (params) => (
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        size="small"
                                        sx={{
                                            width: '100px',
                                            height: '38px',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem',
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                        disabled={params.data?.documenttitle || mappedStatus === 6 || mappedStatus === 7}
                                    >
                                        {params.data.documenttitle ? 'Uploaded' : 'Upload'}
                                        <input
                                            type="file"
                                            hidden
                                            onChange={(event) => handleFileChange(event, params?.data?.id)}
                                        />
                                    </Button>
                                ),
                            },
                            {
                                field: 'documenttitle',
                                headerName: 'File Name',
                                flex: 1,
                            },
                            {
                                field: 'documenttype',
                                headerName: 'File Type',
                                flex: 1,
                            },
                            {
                                field: 'filesize',
                                headerName: 'Size',
                                flex: 1,
                            },
                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Actions',
                                flex: 1,
                                minWidth: 160,
                                cellClassName: 'actions',
                                cellRenderer: (params) => (
                                    <>
                                        {!params?.data?.workRequestFile && (
                                            <CustomTooltip title="Delete">
                                                <Button onClick={handleDeleteClick(params?.data?.id)} disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || ((rows?.length === 1 && params?.data?.id && !params?.data?.documenttitle) ? true : false)} >
                                                    <DeleteIcon />
                                                </Button>
                                            </CustomTooltip>
                                        )}
                                        {params?.data?.filename && (
                                            <CustomTooltip title="Download">
                                                <Button onClick={(event) => handleDownloadClick(event, params?.data)} >
                                                    <DownloadIcon />
                                                </Button>
                                            </CustomTooltip>
                                        )}
                                    </>
                                ),
                            },
                        ]}
                        setGridApi={setGridApi}
                    />
                    {checkCategoryType && <Box>
                        <CreateWOTaskDetails
                            taskDetails={taskDetails}
                            taskDetailsOptions={taskDetailsOptions}
                            onChange={handleCheckboxGroupChange}
                        />
                    </Box>}


                    <Box>
                        <BottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} />
                    </Box>

                </form>

            </Box>
            <CustomDialog
                open={error}
                onClose={handleSnackbarClose}
                content={errorMessage}
                confirmBtn="OK"
                onConfirm={() => setError(false)}
            />

            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                title="Unsaved Changes"
                content="Record(s) not Saved/Updated. Do you want to continue?"
                confirmBtn="Yes"
                cancelBtn="No"
                onConfirm={handleCancelDialogConfirm}
                onCancel={handleCancelDialogClose}
            />
            <CustomDialog
                open={deleteDialogOpen}
                onClose={handleDeleteDialogClose}
                title="Confirm Delete"
                content="Are you sure you want to delete?"
                confirmBtn="Yes"
                cancelBtn="No"
                onConfirm={handleDeleteConfirm}
                onCancel={handleDeleteDialogClose}
            />

        </>
    );
};

export default Attachments;
